// src/pages/CreateActivity.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../hooks/useAuth';
import api from '../services/api';
import { Editor } from '@tinymce/tinymce-react';

const CreateActivity = () => {
  const [name, setName] = useState('');
  const [type, setType] = useState('');
  const [link, setLink] = useState('');
  const [content, setContent] = useState('');
  const [sort, setSort] = useState(0);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setIsSubmitting(true);
    
    try {
      const response = await api.post('/activities', {
        name,
        type,
        link,
        content,
        sort,
      });
      
      setSuccess('Activity created successfully!');
      // Reset form
      setName('');
      setType('');
      setLink('');
      setContent('');
      
      // Scroll to top to show success message
      window.scrollTo(0, 0);
      
      // Navigate back after a delay
      setTimeout(() => {
        navigate('/activities');
      }, 2000);
    } catch (error) {
      setError(error.response?.data?.message || 'Failed to create activity');
      window.scrollTo(0, 0);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="create-activity-container">
      <div className="create-activity-header">
        <button 
          className="back-button"
          onClick={() => navigate('/activities')}
        >
          ← Back to Activities
        </button>
        <h1>Create New Activity</h1>
      </div>
      
      {error && (
        <div className="alert error-alert">
          <div className="alert-icon">!</div>
          <div className="alert-content">{error}</div>
        </div>
      )}
      
      {success && (
        <div className="alert success-alert">
          <div className="alert-icon">✓</div>
          <div className="alert-content">{success}</div>
        </div>
      )}
      
      <div className="activity-form-card">
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="activity-name">Activity Name</label>
            <input
              id="activity-name"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter activity name"
              required
              className="form-control"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="activity-type">Activity Type</label>
            <select
              id="activity-type"
              value={type}
              onChange={(e) => setType(e.target.value)}
              required
              className="form-control"
            >
              <option value="">Select Type</option>
              <option value="pdf">PDF</option>
              <option value="vedio">Video</option>
              <option value="text">Text</option>
            </select>
          </div>
          
          <div className="form-group">
            <label htmlFor="activity-link">Link (Optional)</label>
            <input
              id="activity-link"
              type="url"
              value={link}
              onChange={(e) => setLink(e.target.value)}
              placeholder="https://example.com"
              className="form-control"
            />
            <div className="form-hint">
              Add a URL to external resources related to this activity
            </div>
          </div>
          
          <div className="form-group">
            <label htmlFor="activity-content">Content (Optional)</label>
                <Editor
                  id="activity-content"
                  apiKey="ac83faznllhp9mbx2dbvybjdha3ec6zb21icfh7ont6q9ee3"
                  init={{
                    height: 500,
                    menubar: true,
                    plugins: [
                      'advlist', 'anchor', 'autolink', 'autosave', 'charmap', 'code', 'codesample', 'directionality',
                      'emoticons', 'fullscreen', 'help', 'image', 'importcss', 'insertdatetime', 'link', 'lists',
                      'media', 'nonbreaking', 'pagebreak', 'preview', 'quickbars', 'save', 'searchreplace',
                      'table', 'template', 'visualblocks', 'visualchars', 'wordcount'
                    ],
                    toolbar:
                      'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | ' +
                      'alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist checklist | ' +
                      'forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen preview save print | ' +
                      'insertfile image media template link anchor codesample | ltr rtl | code',
                    directionality: 'auto',
                    content_style: '' // <-- clear style
                  }}
                  placeholder="Enter activity description or instructions"
                  value={content}
                  onEditorChange={(content) => setContent(content)}
                />
            <div className="form-hint">
              Provide detailed instructions or description for this activity
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="activity-sort">Sort Order</label>
            <input
              id="activity-sort"
              type="number"
              value={sort}
              onChange={(e) => setSort(parseInt(e.target.value))}
              className="form-control"
              min="0"
            />
            <div className="form-hint">
              Lower numbers will appear first in the list
            </div>
          </div>


          <div className="form-actions">
            <button 
              type="button" 
              className="cancel-button"
              onClick={() => navigate('/activities')}
            >
              Cancel
            </button>
            <button 
              type="submit" 
              className="submit-button"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <span className="spinner"></span>
                  Creating...
                </>
              ) : 'Create Activity'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateActivity;